import { Box } from '@chakra-ui/react';
import { WrappedImage } from '@time-line/components/common';
import type { SanityImage } from '@time-line/components/types';

import type { ProductCardImageWrapperProps } from './ProductCardImageWrapper';
import { ProductCardImageWrapper } from './ProductCardImageWrapper';

interface ProductCardImageProps extends ProductCardImageWrapperProps {
  alt: string;
  images: SanityImage[];
}

export const PRODUCT_CARD_RATIO = 4 / 5;

export const ProductCardImage = ({
  alt,
  images,
  ratio = PRODUCT_CARD_RATIO,
  ...props
}: ProductCardImageProps) => {
  const primaryImage = images[0];
  const hoverImage = images[1];

  return (
    <ProductCardImageWrapper ratio={ratio} {...props}>
      {primaryImage && (
        <Box width="100%" gridColumn={1} gridRow={1}>
          <WrappedImage
            alt={alt}
            image={primaryImage}
            sizes="(min-width: 1920px) 584px, (min-width: 960px) 30vw, (min-width: 786px) 44vw, 85vw"
            ratio={ratio}
          />
        </Box>
      )}
      {hoverImage && (
        <Box
          width="100%"
          display={{ base: 'none', lg: 'block' }}
          opacity={0}
          bgColor="gray.100"
          transitionProperty="common"
          transitionDuration="slow"
          gridColumn={1}
          gridRow={1}
          sx={{
            '@media(hover: hover) and (pointer: fine)': {
              _groupHover: {
                opacity: 1,
              },
            },
          }}
        >
          <WrappedImage
            alt={alt}
            image={hoverImage}
            sizes="(min-width: 1920px) 584px, (min-width: 960px) 30vw, (min-width: 786px) 44vw, 85vw"
            ratio={ratio}
          />
        </Box>
      )}
    </ProductCardImageWrapper>
  );
};
